import { Colors, FInter, FlexBox, RectangularButtonFilled, RectangularButtonHollow } from "@brg/ui";
import { LayoutConst } from "core";
import styled, { css } from "styled-components";


export const ModalButtonHollow = styled(RectangularButtonHollow)`
    padding: 12px 15px;
    height: 46px !important;
    margin-right: 0;
    line-height: 22px !important;
    font-size: 17px !important;
    width: 100%;

            @media (max-width: ${LayoutConst.screen.mac13}px),
    (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 15px !important;
        line-height: 20px !important;
    }

    @media (max-width: ${LayoutConst.screen.m}px) {
        height: 40px !important;
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {

        height: 36px !important;
    }
`

export const ModalButtonFilled = styled(RectangularButtonFilled)<{ isResumeSubscribe?: boolean }>`
    padding: 12px 15px;
    height: 46px !important;
    margin-height: 0;
    line-height: 22px !important;
    font-size: 17px !important;
    width: 100%;

    ${({ isResumeSubscribe }) => isResumeSubscribe && css`
        min-width: 277px;
    `};
    
    @media (max-width: ${LayoutConst.screen.mac13}px),
    (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 15px !important;
        line-height: 20px !important;
    }

    @media (max-width: ${LayoutConst.screen.m}px) {
        height: 40px !important;
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        height: 36px !important;

        ${({ isResumeSubscribe }) => isResumeSubscribe && css`
            min-width: auto;
        `};
    }
`


export const Wrapper = styled(FlexBox)`
    width: 564px;
    padding: 32px 40px;
    border-radius: 8px;
    gap: 16px;
    background: ${({theme}) => theme.mainBg};
    margin-bottom: 0%;
    max-width: 560px;
    align-items: start;

    svg {
        cursor: pointer;

        path {
            transition: fill 0.2s;
        }

        &:hover {
            path: {
                fill: #151514;
                transition: fill 0.2s;
            }
        }
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        width: calc(100vw - 20px);
        padding: 16px;
    }
`;

export const Title = styled.h1`
    font-family: Inter;
    font-size: 28px;
    font-style: normal;
    font-weight: 600;
    letter-spacing: -0.02em;
    line-height: 34px;
    color: ${({ theme }) => theme.subscribeModal.title};

    @media (max-width: ${LayoutConst.screen.mac13}px),
    (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 23px;
        line-height: 27px;
    }

    @media (max-width: ${LayoutConst.screen.m}px) {
        margin-bottom: 0;
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        font-size: 17px;
        line-height: 22px;
    }
`

export const Subtitle = styled(FInter.Text)`
    font-family: Inter;
    font-size: 17px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: -0.02em;
    color: ${({ theme }) => theme.subscribeModal.title};

        @media (max-width: ${LayoutConst.screen.mac13}px),
    (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 15px;
        line-height: 20px;
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        font-size: 11px;
        line-height: 13px;
    }
`;

export const SmallText = styled.div`
    font-size: 17px;
    line-height: 22px;
    font-weight: 400;
    color: ${Colors.galBlack47};
`;
import { Colors, FInter, FlexBox, RectangularButtonFilled, RectangularButtonHollow } from "@brg/ui";
import { LayoutConst } from "core";
import styled, { css } from "styled-components";


export const ModalButtonHollow = styled(RectangularButtonHollow)`
    padding: 12px 15px;
    height: 46px !important;
    margin-right: 0;
    line-height: 22px !important;
    font-size: 17px !important;
    width: 100%;

            @media (max-width: ${LayoutConst.screen.mac13}px),
    (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 15px !important;
        line-height: 20px !important;
    }

    @media (max-width: ${LayoutConst.screen.m}px) {
        height: 40px !important;
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {

        height: 36px !important;
    }
`

export const ModalButtonFilled = styled(RectangularButtonFilled)<{ isResumeSubscribe?: boolean }>`
    padding: 12px 15px;
    height: 46px !important;
    margin-height: 0;
    line-height: 22px !important;
    font-size: 17px !important;
    width: 100%;

    ${({ isResumeSubscribe }) => isResumeSubscribe && css`
        min-width: 277px;
    `};
    
    @media (max-width: ${LayoutConst.screen.mac13}px),
    (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 15px !important;
        line-height: 20px !important;
    }

    @media (max-width: ${LayoutConst.screen.m}px) {
        height: 40px !important;
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        height: 36px !important;

        ${({ isResumeSubscribe }) => isResumeSubscribe && css`
            min-width: auto;
        `};
    }
`


export const Wrapper = styled(FlexBox)`
    width: 564px;
    padding: 32px 40px;
    border-radius: 8px;
    gap: 16px;
    background: ${({theme}) => theme.mainBg};
    margin-bottom: 0%;
    max-width: 560px;
    align-items: start;

    svg {
        cursor: pointer;

        path {
            transition: fill 0.2s;
        }

        &:hover {
            path: {
                fill: #151514;
                transition: fill 0.2s;
            }
        }
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        width: calc(100vw - 20px);
        padding: 16px;
    }
`;

export const Title = styled.h1`
    font-family: Inter;
    font-size: 28px;
    font-style: normal;
    font-weight: 600;
    letter-spacing: -0.02em;
    line-height: 34px;
    color: ${({ theme }) => theme.subscribeModal.title};

    @media (max-width: ${LayoutConst.screen.mac13}px),
    (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 23px;
        line-height: 27px;
    }

    @media (max-width: ${LayoutConst.screen.m}px) {
        margin-bottom: 0;
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        font-size: 17px;
        line-height: 22px;
    }
`

export const Subtitle = styled(FInter.Text)`
    font-family: Inter;
    font-size: 17px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: -0.02em;
    color: ${({ theme }) => theme.subscribeModal.title};

        @media (max-width: ${LayoutConst.screen.mac13}px),
    (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 15px;
        line-height: 20px;
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        font-size: 11px;
        line-height: 13px;
    }
`;

export const SmallText = styled.div`
    font-size: 17px;
    line-height: 22px;
    font-weight: 400;
    color: ${Colors.galBlack47};
`;
